import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common';
import {
  EndUserLicenseAgreementItemFileInitialState,
  EndUserLicenseAgreementItemFileLoad,
  EndUserLicenseAgreementLastItemFileLoad,
} from './end-user-license-agreement-item-file.actions';
import { EndUserLicenseAgreementItemFileService } from './end-user-license-agreement-item-file.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface EndUserLicenseAgreementItemFileStateModel {
  eulaFileText: string;
  loaded: boolean;
}

const initialState: EndUserLicenseAgreementItemFileStateModel = {
  eulaFileText: null,
  loaded: false,
};

@State<EndUserLicenseAgreementItemFileStateModel>({
  name: 'endUserLicenseAgreementItemFile',
  defaults: initialState,
})
@Injectable()
export class EndUserLicenseAgreementItemFileState {
  @Selector()
  static getState(state: EndUserLicenseAgreementItemFileStateModel): EndUserLicenseAgreementItemFileStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: EndUserLicenseAgreementItemFileStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private eulaItemFileService: EndUserLicenseAgreementItemFileService,
    private notificationService: NotificationService,
  ) {}

  @Action(EndUserLicenseAgreementItemFileLoad)
  getEulaItemFile(
    ctx: StateContext<EndUserLicenseAgreementItemFileStateModel>,
    { payload }: EndUserLicenseAgreementItemFileLoad,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.eulaItemFileService.getEulaItemFile(payload).pipe(
      map((eulaFileText: string) => {
        ctx.patchState({ eulaFileText, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(EndUserLicenseAgreementLastItemFileLoad)
  getLastEulaItemFile(
    ctx: StateContext<EndUserLicenseAgreementItemFileStateModel>,
    { payload }: EndUserLicenseAgreementLastItemFileLoad,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.eulaItemFileService.getLastEulaItemFile(payload).pipe(
      map((eulaFileText: string) => {
        ctx.patchState({ eulaFileText, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(EndUserLicenseAgreementItemFileInitialState)
  setInitialState(ctx: StateContext<EndUserLicenseAgreementItemFileStateModel>): void {
    ctx.setState(initialState);
  }
}
